import React from 'react';
import { Button as MuiButton, ButtonProps as MuiButtonProps, CircularProgress } from '@mui/material';

export interface ButtonProps extends Omit<MuiButtonProps, 'variant'> {
  variant?: 'primary' | 'secondary' | 'danger' | 'success';
  loading?: boolean;
  children: React.ReactNode;
}

const Button: React.FC<ButtonProps> = ({ 
  variant = 'primary', 
  loading = false, 
  disabled,
  children,
  ...props 
}) => {
  const getVariantProps = () => {
    switch (variant) {
      case 'primary':
        return { color: 'primary' as const, variant: 'contained' as const };
      case 'secondary':
        return { color: 'secondary' as const, variant: 'outlined' as const };
      case 'danger':
        return { color: 'error' as const, variant: 'contained' as const };
      case 'success':
        return { color: 'success' as const, variant: 'contained' as const };
      default:
        return { color: 'primary' as const, variant: 'contained' as const };
    }
  };

  const variantProps = getVariantProps();

  return (
    <MuiButton
      {...variantProps}
      {...props}
      disabled={disabled || loading}
      sx={{
        textTransform: 'none',
        fontWeight: 500,
        borderRadius: 2,
        padding: '8px 16px',
        minHeight: 44, // Minimum touch target
        '&:hover': {
          transform: 'scale(1.02)',
          transition: 'transform 150ms ease-out',
        },
        ...props.sx,
      }}
    >
      {loading ? (
        <CircularProgress size={20} color="inherit" />
      ) : (
        children
      )}
    </MuiButton>
  );
};

export default Button;
